import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";
// import RichTextEditor from "./RichTextEditor";

export const AddQuestion = () => {

    const { apipath, logout, goBack } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const testId = localStorage.getItem('testId');
    const examId = localStorage.getItem('examId');
    const [isLoading, setIsLoading] = useState(false);
    const [subjects, setSubjects] = useState([]);
    const [language, setLanguage] = useState('english');

    // const [question, setQuestion] = useState("");
    const getTest = async () => {
        try {
            if(examId === "" || examId === null){
                navigate('/tests');
                return false;
            }
            console.log(examId);
            const response = await axios.post(
                apipath + '/subjects',
                { 'exam_id': examId },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "false") {
                iziToast.error({
                    'message': response.data.message,
                    'position': 'topCenter',
                })
                // localStorage.removeItem('token');
                // navigate('/');
            }
            setSubjects(response.data.subjects);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }
            // if (localStorage.getItem('token')) {
            //     localStorage.removeItem('token');
            // }
            // navigate('/');

        } finally {

        }
    }
    useEffect(() => {
        getTest();
    }, []);
    const [activeTab, setActiveTab] = useState("Test");
    const [formData, setFormData] = useState({
        test: testId,
        subject: '',
        language: 'english',
        description: '',
        question: '',
        question_image: null,
        option1: '',
        option1_image: null,
        option2: '',
        option2_image: null,
        option3: '',
        option3_image: null,
        option4: '',
        option4_image: null,
        answer: '',
        marks: 0,
    });

    const [errors, setErrors] = useState({});

    const handleFileChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.files[0] });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.subject) {
            newErrors.subject = "Subject is required.";
        }
        if (!formData.language) {
            newErrors.language = "Language is required.";
        }

        if (!formData.question && !formData.question_image) {
            newErrors.question = "Question is required.";
        }

        if (!formData.option1 && !formData.option1_image) {
            newErrors.option1 = "Option 1 is required. Please Enter Text or Select Image";
        }

        if (!formData.option2 && !formData.option2_image) {
            newErrors.option2 = "Option 2 is required. Please Enter Text or Select Image";
        }

        if (!formData.option3 && !formData.option3_image) {
            newErrors.option3 = "Option 3 is required. Please Enter Text or Select Image";
        }

        if (!formData.option4 && !formData.option4_image) {
            newErrors.option4 = "Option 4 is required. Please Enter Text or Select Image";
        }

        if (!formData.answer) {
            newErrors.answer = "Please select the correct answer.";
        }
        if (!formData.marks || formData.marks <= 0) {
            newErrors.marks = "Please enter valid marks for the question.";
        }

        setErrors(newErrors);

        // Return true if no errors
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setIsLoading(true);
            // console.log("Form submitted successfully", formData);
            // Submit your form or send the data to the backend

            try {
                const response = await axios.post(
                    apipath + '/add_question', formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                console.log(response.data);
                if (response.data.status === "false") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                }
                else {
                    iziToast.success({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    localStorage.removeItem('testId');
                    localStorage.removeItem('examId');
                    // localStorage.removeItem('testQues');
                    navigate('/tests');
                }
            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }
            }
            finally {
                setIsLoading(false);
            }
        }
    };
    useEffect(()=>{
        console.log(language);
    },[language]);

    if(testId === "" || examId === "" || testId === null || examId === null){
        navigate('/tests');
        return false;
    }

    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
                Loading...
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"tests"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                            <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={()=>goBack()}></i>Add Question</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/exams`}><span class={`md:ml-5 ml-2 ${activeTab === 'Exam' ? 'bg-teal-900 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Exams
                                </span></Link>
                                <Link to={`/tests`}><span class={`md:ml-5 ml-2 ${activeTab === 'Test' ? 'bg-teal-900 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Tests
                                </span></Link>
                            </div> */}
                        </div>
                        {/* <div class="bg-gradient-to-r from-teal-900 to-teal-900 px-4 py-2 shadow text-base text-white">
                            <h3 class="font-medium pl-2">Users</h3>
                        </div> */}
                    </div>

                    <div class="flex flex-wrap">
                        <div className="w-full p-6">
                            <form onSubmit={handleSubmit} className="mx-auto p-4 space-y-6 bg-white rounded-lg shadow-lg">
                                <h2 className="text-2xl font-bold text-center">Create Multiple Choice Question</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                    {/* Select Subject */}
                                    <div>
                                        <label className="block font-medium">Select Subject</label>
                                        <select
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        >
                                            <option value="">Select Subject</option>
                                            {/* Add subject options here */}
                                            {subjects.map((sub) => (
                                                <>
                                                    <option value={sub.subject}>{sub.subject}</option>
                                                </>
                                            ))}
                                        </select>
                                        {errors.subject && <p className="text-red-500 text-sm">{errors.subject}</p>}
                                    </div>
                                    {/* Select Language */}
                                    <div>
                                        <label className="block font-medium">Select Language</label>
                                        <select
                                            name="language"
                                            value={formData.language}
                                            onChange={(e) => {
                                                setLanguage(e.target.value);
                                                handleChange(e); 
                                            }}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        >
                                            <option value="english">English</option>
                                            <option value="hindi">Hindi</option>
                                            <option value="punjabi">Punjabi</option>
                                            {/* <option value="urdu">Urdu</option> */}
                                        </select>
                                        {errors.language && <p className="text-red-500 text-sm">{errors.language}</p>}
                                    </div>

                                    {/* Question Text */}
                                    <div className="md:col-span-2">
                                        <label className="block font-medium">Description</label>
                                        <textarea
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            className={`w-full border px-3 py-2 rounded focus:outline-none ${language}`}
                                        />
                                        {errors.description && <p className="text-red-500 text-sm">{errors.description}</p>}
                                    </div>

                                    {/* Question Text */}
                                    <div className="md:col-span-2">
                                        <label className="block font-medium">Question</label>
                                        {/* <RichTextEditor value={question} onChange={setQuestion} /> */}
                                        <textarea
                                            name="question"
                                            value={formData.question}
                                            onChange={handleChange}
                                            className={`w-full border px-3 py-2 rounded focus:outline-none ${language}`}
                                        />
                                        {errors.question && <p className="text-red-500 text-sm">{errors.question}</p>}
                                    </div>

                                    {/* Question Image */}
                                    <div className="md:col-span-2">
                                        <label className="block font-medium">Question Image</label>
                                        <input
                                            type="file"
                                            name="question_image"
                                            onChange={handleFileChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.question_image && <p className="text-red-500 text-sm">{errors.question_image}</p>}
                                    </div>

                                    {/* Option 1 */}
                                    <div>
                                        <label className="block font-medium">Option 1</label>
                                        <input
                                            type="text"
                                            name="option1"
                                            value={formData.option1}
                                            onChange={handleChange}
                                            className={`w-full border px-3 py-2 rounded focus:outline-none ${language}`}
                                        />
                                        {errors.option1 && <p className="text-red-500 text-sm">{errors.option1}</p>}
                                    </div>

                                    {/* Option 1 Image */}
                                    <div>
                                        <label className="block font-medium">Option 1 Image</label>
                                        <input
                                            type="file"
                                            name="option1_image"
                                            onChange={handleFileChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.option1_image && <p className="text-red-500 text-sm">{errors.option1_image}</p>}
                                    </div>

                                    {/* Option 2 */}
                                    <div>
                                        <label className="block font-medium">Option 2</label>
                                        <input
                                            type="text"
                                            name="option2"
                                            value={formData.option2}
                                            onChange={handleChange}
                                            className={`w-full border px-3 py-2 rounded focus:outline-none ${language}`}
                                        />
                                        {errors.option2 && <p className="text-red-500 text-sm">{errors.option2}</p>}
                                    </div>

                                    {/* Option 2 Image */}
                                    <div>
                                        <label className="block font-medium">Option 2 Image</label>
                                        <input
                                            type="file"
                                            name="option2_image"
                                            onChange={handleFileChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.option2_image && <p className="text-red-500 text-sm">{errors.option2_image}</p>}
                                    </div>

                                    {/* Option 3 */}
                                    <div>
                                        <label className="block font-medium">Option 3</label>
                                        <input
                                            type="text"
                                            name="option3"
                                            value={formData.option3}
                                            onChange={handleChange}
                                            className={`w-full border px-3 py-2 rounded focus:outline-none ${language}`}
                                        />
                                        {errors.option3 && <p className="text-red-500 text-sm">{errors.option3}</p>}
                                    </div>

                                    {/* Option 3 Image */}
                                    <div>
                                        <label className="block font-medium">Option 3 Image</label>
                                        <input
                                            type="file"
                                            name="option3_image"
                                            onChange={handleFileChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.option3_image && <p className="text-red-500 text-sm">{errors.option3_image}</p>}
                                    </div>

                                    {/* Option 4 */}
                                    <div>
                                        <label className="block font-medium">Option 4</label>
                                        <input
                                            type="text"
                                            name="option4"
                                            value={formData.option4}
                                            onChange={handleChange}
                                            className={`w-full border px-3 py-2 rounded focus:outline-none ${language}`}
                                        />
                                        {errors.option4 && <p className="text-red-500 text-sm">{errors.option4}</p>}
                                    </div>

                                    {/* Option 4 Image */}
                                    <div>
                                        <label className="block font-medium">Option 4 Image</label>
                                        <input
                                            type="file"
                                            name="option4_image"
                                            onChange={handleFileChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.option4_image && <p className="text-red-500 text-sm">{errors.option4_image}</p>}
                                    </div>

                                    {/* Correct Answer */}
                                    <div className="md:col-span-2">
                                        <label className="block font-medium">Correct Answer</label>
                                        <select
                                            name="answer"
                                            value={formData.answer}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        >
                                            <option value="">Select Correct Answer</option>
                                            <option value="a">Option 1</option>
                                            <option value="b">Option 2</option>
                                            <option value="c">Option 3</option>
                                            <option value="d">Option 4</option>
                                        </select>
                                        {errors.answer && <p className="text-red-500 text-sm">{errors.answer}</p>}
                                    </div>
                                    <div>
                                        <label className="block font-medium">Marks</label>
                                        <input
                                            type="number"
                                            name="marks"
                                            value={formData.marks}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.marks && <p className="text-red-500 text-sm">{errors.marks}</p>}
                                    </div>
                                </div>

                                <div className="text-center">
                                    <button type="submit" className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-700">
                                        Create Question
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
};